import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'm',
  templateUrl: './m.component.html',
  styleUrls: ['./m.component.scss']
})
export class MComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
